"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateMarketRequirements = exports.createOrderAccountIx = exports.createOrderIx = exports.generateSellNoAccObj = exports.generateInitBuyNoAccObj = exports.generateBuyNoAccObj = exports.generateInitTradeYesAccObj = exports.generateInitSellNoAccObj = exports.generateTradeYesAccObj = void 0;
const InternalTokenAuth_1 = require("./../generated/accounts/InternalTokenAuth");
const token_1 = require("@project-serum/anchor/dist/cjs/utils/token");
const web3_js_1 = require("@solana/web3.js");
const consts_1 = require("../consts");
const instructions_1 = require("../generated/instructions");
const accounts_1 = require("../generated/accounts");
function generateTradeYesAccObj(provider, pubkeys) {
    const user = new web3_js_1.PublicKey(provider.wallet.publicKey);
    const { bracket, lockedYesFUsdc, unlockedYes, userUsdc, dexProgram, fUsdcMint, usdcVault, tradeYesAccount, market, openOrdersYes, serumMarket, serumAccounts, marketPnl, } = pubkeys;
    return {
        bracket,
        serumAccounts,
        serumMarket,
        usdcVault,
        market,
        fUsdcMint,
        tradeYes: tradeYesAccount,
        openOrders: openOrdersYes,
        unlockedYes,
        lockedFUsdc: lockedYesFUsdc,
        user,
        userUsdc,
        marketPnl,
        dexProgram,
        tokenProgram: token_1.TOKEN_PROGRAM_ID,
        rent: web3_js_1.SYSVAR_RENT_PUBKEY,
    };
}
exports.generateTradeYesAccObj = generateTradeYesAccObj;
function generateInitSellNoAccObj(provider, pubkeys) {
    const { bracket, dexProgram, fUsdcMint, yesMint, noMint, serumMarket, tradeNoAccount, openOrdersSellNo, lockedSellNoFUsdc, lockedSellNoYes, lockedSellNoNo, } = pubkeys;
    return {
        user: new web3_js_1.PublicKey(provider.wallet.publicKey),
        bracket,
        serumMarket,
        yesMint,
        noMint,
        fUsdcMint,
        tradeNo: tradeNoAccount,
        openOrders: openOrdersSellNo,
        lockedYes: lockedSellNoYes,
        lockedNo: lockedSellNoNo,
        lockedFUsdc: lockedSellNoFUsdc,
        dexProgram,
        tokenProgram: token_1.TOKEN_PROGRAM_ID,
        rent: web3_js_1.SYSVAR_RENT_PUBKEY,
        systemProgram: web3_js_1.SystemProgram.programId,
    };
}
exports.generateInitSellNoAccObj = generateInitSellNoAccObj;
function generateInitTradeYesAccObj(provider, pubkeys) {
    const { bracket, lockedYesFUsdc, unlockedYes, dexProgram, fUsdcMint, yesMint, tradeYesAccount, openOrdersYes, serumMarket, internalUsdc, marketPnl, } = pubkeys;
    const user = new web3_js_1.PublicKey(provider.wallet.publicKey);
    return {
        user,
        internalUsdc,
        bracket,
        tradeYes: tradeYesAccount,
        serumMarket,
        openOrders: openOrdersYes,
        yesMint,
        fUsdcMint,
        unlockedYes,
        lockedFUsdc: lockedYesFUsdc,
        dexProgram,
        marketPnl,
        tokenProgram: token_1.TOKEN_PROGRAM_ID,
        rent: web3_js_1.SYSVAR_RENT_PUBKEY,
        systemProgram: web3_js_1.SystemProgram.programId,
    };
}
exports.generateInitTradeYesAccObj = generateInitTradeYesAccObj;
function generateBuyNoAccObj(provider, pubkeys) {
    const user = new web3_js_1.PublicKey(provider.wallet.publicKey);
    const { bracket, userUsdc, dexProgram, fUsdcMint, usdcVault, yesMint, noMint, market, serumMarket, unlockedNo, serumAccounts, tradeNoAccount, openOrdersBuyNo, lockedBuyNoFUsdc, lockedBuyNoYes, marketPnl, } = pubkeys;
    return {
        user,
        market,
        userUsdc,
        bracket,
        serumMarket,
        serumAccounts,
        usdcVault,
        yesMint,
        noMint,
        fUsdcMint,
        tradeNo: tradeNoAccount,
        marketPnl,
        openOrders: openOrdersBuyNo,
        lockedYes: lockedBuyNoYes,
        lockedFUsdc: lockedBuyNoFUsdc,
        unlockedNo,
        dexProgram,
        tokenProgram: token_1.TOKEN_PROGRAM_ID,
        rent: web3_js_1.SYSVAR_RENT_PUBKEY,
    };
}
exports.generateBuyNoAccObj = generateBuyNoAccObj;
function generateInitBuyNoAccObj(provider, pubkeys) {
    const { bracket, dexProgram, fUsdcMint, yesMint, noMint, serumMarket, internalUsdc, unlockedNo, tradeNoAccount, openOrdersBuyNo, lockedBuyNoFUsdc, lockedBuyNoYes, marketPnl, } = pubkeys;
    return {
        user: new web3_js_1.PublicKey(provider.wallet.publicKey),
        bracket,
        tradeNo: tradeNoAccount,
        marketPnl,
        serumMarket,
        yesMint,
        noMint,
        fUsdcMint,
        internalUsdc,
        openOrders: openOrdersBuyNo,
        lockedYes: lockedBuyNoYes,
        lockedFUsdc: lockedBuyNoFUsdc,
        unlockedNo,
        dexProgram,
        tokenProgram: token_1.TOKEN_PROGRAM_ID,
        rent: web3_js_1.SYSVAR_RENT_PUBKEY,
        systemProgram: web3_js_1.SystemProgram.programId,
    };
}
exports.generateInitBuyNoAccObj = generateInitBuyNoAccObj;
function generateSellNoAccObj(provider, pubkeys) {
    const { bracket, userUsdc, dexProgram, fUsdcMint, usdcVault, yesMint, noMint, market, serumMarket, unlockedNo, serumAccounts, tradeNoAccount, openOrdersSellNo, lockedSellNoFUsdc, lockedSellNoYes, lockedSellNoNo, marketPnl, } = pubkeys;
    return {
        user: new web3_js_1.PublicKey(provider.wallet.publicKey),
        userUsdc,
        bracket,
        market,
        marketPnl,
        serumAccounts,
        serumMarket,
        usdcVault,
        yesMint,
        noMint,
        fUsdcMint,
        tradeNo: tradeNoAccount,
        openOrders: openOrdersSellNo,
        lockedYes: lockedSellNoYes,
        lockedNo: lockedSellNoNo,
        lockedFUsdc: lockedSellNoFUsdc,
        unlockedNo,
        dexProgram,
        tokenProgram: token_1.TOKEN_PROGRAM_ID,
        rent: web3_js_1.SYSVAR_RENT_PUBKEY,
    };
}
exports.generateSellNoAccObj = generateSellNoAccObj;
const createOrderIx = ({ type, provider, pubkeys, constArgs, }) => {
    let tradeIx;
    if (type === consts_1.MARKET_TYPE.BUY_YES || type === consts_1.MARKET_TYPE.SELL_YES) {
        let accounts = generateTradeYesAccObj(provider, pubkeys);
        if (type === consts_1.MARKET_TYPE.BUY_YES) {
            tradeIx = (0, instructions_1.buyYes)(constArgs, accounts);
        }
        else {
            tradeIx = (0, instructions_1.sellYes)(constArgs, accounts);
        }
    }
    else if (type === consts_1.MARKET_TYPE.BUY_NO) {
        let accounts = generateBuyNoAccObj(provider, pubkeys);
        tradeIx = (0, instructions_1.buyNo)(constArgs, accounts);
    }
    else if (type === consts_1.MARKET_TYPE.SELL_NO) {
        let accounts = generateSellNoAccObj(provider, pubkeys);
        tradeIx = (0, instructions_1.sellNo)(constArgs, accounts);
    }
    else {
        throw new Error(`Unexpected type: ${type}`);
    }
    return tradeIx;
};
exports.createOrderIx = createOrderIx;
const createOrderAccountIx = ({ type, provider, pubkeys, }) => {
    let initIx;
    if (type === consts_1.MARKET_TYPE.BUY_YES || type === consts_1.MARKET_TYPE.SELL_YES) {
        const bumps = pubkeys.tradeYesBumps;
        let initAccountObj = generateInitTradeYesAccObj(provider, pubkeys);
        initIx = (0, instructions_1.initTradesYes)({ bumps }, initAccountObj);
    }
    else if (type === consts_1.MARKET_TYPE.BUY_NO) {
        let initAccountObj = generateInitBuyNoAccObj(provider, pubkeys);
        const bumps = pubkeys.buyNoBumps;
        initIx = (0, instructions_1.initBuyNo)({ bumps }, initAccountObj);
    }
    else if (type === consts_1.MARKET_TYPE.SELL_NO) {
        let initAccountObj = generateInitSellNoAccObj(provider, pubkeys);
        const bumps = pubkeys.sellNoBumps;
        initIx = (0, instructions_1.initSellNo)({ bumps }, initAccountObj);
    }
    else {
        throw new Error(`Unexpected type: ${type}`);
    }
    return initIx;
};
exports.createOrderAccountIx = createOrderAccountIx;
const generateMarketRequirements = async ({ pubkeys, usdcMint, provider, }) => {
    let programInstructions = [];
    const internalTokenAuth = await InternalTokenAuth_1.InternalTokenAuth.fetch(provider.connection, pubkeys.internalTokenAuth);
    const marketPnl = await accounts_1.MarketPnl.fetch(provider.connection, pubkeys.marketPnl);
    if (!marketPnl) {
        if (!internalTokenAuth) {
            programInstructions.push((0, instructions_1.initInternalUsdc)({
                internalTokenAuthBump: pubkeys.miscBumps.internalTokenAuthBump,
                internalUsdcBump: pubkeys.miscBumps.internalUsdcBump,
            }, {
                user: new web3_js_1.PublicKey(provider.wallet.publicKey),
                internalTokenAuth: pubkeys.internalTokenAuth,
                internalUsdc: pubkeys.internalUsdc,
                tokenProgram: token_1.TOKEN_PROGRAM_ID,
                rent: web3_js_1.SYSVAR_RENT_PUBKEY,
                usdcMint,
                systemProgram: web3_js_1.SystemProgram.programId,
            }));
        }
        programInstructions.push((0, instructions_1.initMarketPnl)({ bump: pubkeys.miscBumps.marketPnlBump }, {
            user: new web3_js_1.PublicKey(provider.wallet.publicKey),
            market: pubkeys.market,
            marketPnl: pubkeys.marketPnl,
            systemProgram: web3_js_1.SystemProgram.programId,
        }));
    }
    return programInstructions;
};
exports.generateMarketRequirements = generateMarketRequirements;
//# sourceMappingURL=trades.js.map